<template>
  <div>
    <p style="text-align: center;">
      <!-- 培训师查询 -->
      <span class="systemFont1">{{ $t("p0433.trainerSearch") }}</span>
    </p>

    <el-row style="top: 17px;">
      <el-col :span="22" :offset="1" style="text-align: left;">
        <!-- 模糊查询 -->
        <el-col :span="1">
          <!-- 新增 -->
          <el-button
            class="submitButton"
            type="submit"
            @click="addMarketingUserClick()"
            >{{ $t("common.new") }}</el-button
          >
        </el-col>
        <el-form
          :model="queryForm"
          label-position="right"
          ref="queryForm"
          label-width="80px"
          class="systemFont1"
        >
          <!-- 关键字 -->
          <el-col :span="6" :offset="1">
            <el-form-item :label="$t('p0433.personalUser')">
              <el-input
                name="queryForm.param1"
                type="text"
                size="courseSelect"
                v-model="queryForm.param1"
                maxlength="60"
                clearable
                :placeholder="$t('p0433.searchPlaceholder')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 课程名称 -->
          <el-col :span="6" style="margin-left:5px">
            <el-form-item :label="$t('p0433.courseName')">
              <el-input
                name="queryForm.param2"
                type="text"
                size="courseSelect"
                v-model="queryForm.param2"
                maxlength="60"
                clearable
                :placeholder="$t('p0433.searchPlaceholder1')"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 资格状态 -->
          <el-col style="width: 200px; margin-left:5px">
            <el-form-item :label="$t('p0433.qualificationStatus')">
              <el-select
                v-model="queryForm.param3"
                size="courseSelect"
                style="width: 100%"
                :placeholder="$t('common.pleaseSelect')"
                clearable
              >
                <el-option
                  v-for="item in isTrainTeacherOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col style="width: 200px;">
            <!-- 查询 -->
            <el-button type="submit" class="submitButton" style="margin-left:15px" @click="init(true)">{{
              $t("common.query")
            }}</el-button>
            <!-- 重置 -->
            <el-button type="submit" class="buttonWidth" @click="reset">{{
              $t("common.reset")
            }}</el-button>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
    <!-- 培训师一览 -->
    <el-row style="top: 17px ;">
      <el-col :span="22" :offset="1">
        <el-table :data="TrainerTable">
          <!-- 姓名 -->
          <el-table-column
            fixed="left"
            min-width="130px"
            prop="name"
            :label="$t('p0433.userName')"
            align="left"
          ></el-table-column>
          <!-- 英文姓名 -->
          <el-table-column
            min-width="230px"
            prop="nameEn"
            :label="$t('p0433.englishName')"
            align="left"
          ></el-table-column>
          <!-- 昵称 -->
          <el-table-column
            min-width="130px"
            prop="nickname"
            :label="$t('p0433.nickname')"
            align="left"
          ></el-table-column>
          <!-- 注册邮箱 -->
          <el-table-column
            prop="email"
            :label="$t('p0433.registeredEmail')"
            align="left"
            width="300px"
          ></el-table-column>
          <!-- 注册手机 -->
          <el-table-column
            prop="phone"
            :label="$t('p0433.registeredMobile')"
            align="center"
            width="150px"
          ></el-table-column>
          <!-- 关联公司 -->
          <el-table-column
            prop="existingCompany"
            :label="$t('p0433.existingCompany')"
            align="left"
            min-width="180px"
          ></el-table-column>
          <!-- 职位 -->
          <el-table-column
            prop="position"
            :label="$t('p0433.position')"
            align="left"
          ></el-table-column>
          <!-- 认证课程数 -->
          <el-table-column
            fixed="right"
            prop="courseCount"
            :label="$t('p0433.certifiedCourseCount')"
            align="right"
            width="100px"
          >
            <template slot-scope="scope">
              {{ scope.row.courseCount == null ? 0 : scope.row.courseCount }}
            </template>
          </el-table-column>
          <!-- 资格状态 -->
          <el-table-column
            fixed="right"
            prop="isTrainTeacher"
            :label="$t('p0433.qualificationStatus')"
            align="center"
            width="90px"
          >
            <template slot-scope="scope">
              <span
                :style="
                  scope.row.isTrainTeacher == '1'
                    ? 'color:rgb(8,193,58)'
                    : 'color:red'
                "
                >{{ isTrainTeacherFormat(scope.row.isTrainTeacher) }}</span
              >
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column
            fixed="right"
            :label="$t('common.operation')"
            align="center"
            width="320px"
          >
            <template slot-scope="scope">
              <!-- 认证课程 -->
              <el-button
                size="text"
                :disabled="scope.row.isTrainTeacher !== '1'"
                @click="certifiedCoursesClick(scope.row.userId)"
                >{{ $t("p0433.certificationCourse") }}</el-button
              >
              <!-- 上课明细 -->
              <el-button
                size="text"
                @click="teacherClassClick(scope.row.userId)"
                >{{ $t("p0433.classDetails") }}</el-button
              >
              <!-- 详情 -->
              <el-button size="text" @click="gotoUserDetails(scope.row)">{{
                $t("common.details")
              }}</el-button>
              <!-- 取消、恢复培训师资格 -->
              <el-button
                v-if="scope.row.isTrainTeacher === '1'"
                size="text"
                @click="open(scope.row, '2')"
                >{{ $t("p0433.cancelTrainerQualification") }}</el-button
              >
              <!-- 恢复培训师资格 -->
              <el-button
                v-if="scope.row.isTrainTeacher === '2'"
                size="text"
                @click="updateIsTrainTeacherApi(scope.row, '1')"
                >{{ $t("p0433.restoreTrainerQualification") }}</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-row style="text-align: right; margin: 20px">
          <el-col :span="24">
            <div class="block">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPageCo"
                :page-sizes="[10, 20, 50]"
                :page-size="pageSizeCo"
                layout="total, sizes, prev, pager, next"
                :total="totalCo"
              >
              </el-pagination>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 认证课程 -->
    <el-dialog
      :title="$t('p0433.certificationCourse')"
      class="roll-dialog"
      :close-on-click-modal="false"
      :visible.sync="certifiedCoursesV"
      width="70%"
      center
      @close="closeDialog"
    >
      <p0434
        :user-id="userId"
        :certifiedCoursesWatch="certifiedCoursesWatch"
        ref="p0434Ref"
      ></p0434>
    </el-dialog>
    <!-- 上课明细 -->
    <el-dialog
      :title="$t('p0433.classDetails')"
      class="roll-dialog"
      :close-on-click-modal="false"
      :visible.sync="teacherClassV"
      width="1200px"
      center
      @close="closeDialog"
    >
      <p0435
        :user-id="userId"
        :teacherClassWatch="teacherClassWatch"
        ref="p0435Ref"
      ></p0435>
    </el-dialog>
    <!-- 共通新增 -->
    <el-dialog
      :title="$t('p0433.addTrainer')"
      class="add_roll-dialog"
      :close-on-click-modal="false"
      :visible.sync="marketingUserV"
      width="70%"
      top="8vh"
      center
      @close="closeDialog"
    >
      <p0438
        :pageNo="2"
        :marketingUserWatch="marketingUserWatch"
        ref="p0438Ref"
      ></p0438>
    </el-dialog>
  </div>
</template>

<script>
import p0434 from "../MarketingMgt/P0434";
import p0435 from "../MarketingMgt/P0435";
import p0438 from "../MarketingMgt/commonPg/P0438";
export default {
  name: "p0433demo",
  components: {
    p0434,
    p0435,
    p0438
  },
  data() {
    return {
      userId: "",
      // 认证课程弹窗
      certifiedCoursesV: false,
      certifiedCoursesWatch: false,
      // 上课明细弹窗
      teacherClassV: false,
      teacherClassWatch: false,
      // 新增共通弹窗
      marketingUserV: false,
      marketingUserWatch: false,
      // 一览数据
      TrainerTable: [],
      // 查询条件
      queryForm: {
        param1: "",
        param1: "",
        param3: ""
      },
      isTrainTeacherOptions: [
        { value: 1, label: this.$t("p0433.normal") },
        { value: 2, label: this.$t("common.cancel") }
      ],
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 10,
      totalCo: 0
    };
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (this.TrainerTable == undefined || this.TrainerTable.length <= 0) {
        return;
      }
      this.init(false);
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.init(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化培训师一览数据
    init(val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      let url = "/api/TrainerManagement/selectTrainerManagementList";
      this.$http
        .post(url, {
          //模糊查询
          param1: this.queryForm.param1,
          param2: this.queryForm.param2,
          param3: this.queryForm.param3,
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            // 判断有没有数据
            if (response.data.data == null) {
              this.TrainerTable = [];
            } else {
              // 总数取值
              this.totalCo = response.data.data[0].totalCo;
              // 渲染页面
              this.TrainerTable = response.data.data;
            }
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 取消培训资格确认
    open(row, val) {
      this.$confirm(
        this.$t("p0433.disqualifyTraining"),
        this.$t("common.tips"),
        {
          confirmButtonText: this.$t("common.confirm"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }
      )
        .then(() => {
          this.updateIsTrainTeacherApi(row, val);
        })
        .catch(() => {});
    },
    // 更新培训师资格
    updateIsTrainTeacherApi(row, val) {
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        background: "rgba(255,255,255,0.8)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/TrainerManagement/updateIsTrainTeacher";
      this.$http
        .post(url, {
          userId: row.userId,
          isTrainTeacher: val,
          updateUser: localStorage.getItem("userId")
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.handleCurrentChange(this.currentPageCo);
            this.$message({
              type: "success",
              message: this.$t("p0433.operationSuccess")
            });
          }
        });
    },
    // 培训师状态format
    isTrainTeacherFormat(value) {
      return value == "1" ? this.$t("p0433.normal") : this.$t("common.cancel");
    },
    // 重置搜索表单
    reset() {
      this.queryForm.param1 = "";
      this.queryForm.param2 = "";
      this.queryForm.param3 = "";
      this.init(true);
    },
    // 跳转到用户详细画面
    gotoUserDetails(row) {
      // 用户ID和当前页记录
      let p0212 = JSON.stringify({
        userID: row.userId,
        currentPage: this.currentPageCo
      });
      sessionStorage.p0212 = p0212;
      // // 分页相关变量记录
      sessionStorage.setItem("total", this.totalCo);
      sessionStorage.setItem("pageSize", this.pageSizeCo);
      let query = JSON.stringify(this.queryForm);
      // // 检索条件记录
      sessionStorage.setItem("queryCriteria", query);
      // 跳转指定页面
      this.$router.push({
        path: "/views/CustomerInfoBase/P0213"
      });
    },
    // 认证课程弹窗
    certifiedCoursesClick(userId) {
      this.userId = userId;
      // 刷新弹窗
      this.certifiedCoursesWatch = !this.certifiedCoursesWatch;
      this.certifiedCoursesV = true;
    },
    // 上课明细弹窗
    teacherClassClick(userId) {
      this.userId = userId;
      // 刷新弹窗
      this.teacherClassWatch = !this.teacherClassWatch;
      this.teacherClassV = true;
    },
    // 新增弹窗
    addMarketingUserClick(userId) {
      // 刷新弹窗
      this.marketingUserWatch = !this.marketingUserWatch;
      this.marketingUserV = true;
    },
    //返回跳转前的页面
    getInit() {
      //当从详情页返回的时候，先获取详情页中存下来的detall标识，在列表页中，把获取到的分页页码重新赋值，用以返回前的页面，保持不变
      if (sessionStorage.getItem("detail")) {
        //如果有这个就读取缓存里面的数据
        this.currentPageCo = Number(sessionStorage.getItem("currentPage"));
        this.totalCo = Number(sessionStorage.getItem("total"));
        this.pageSizeCo = Number(sessionStorage.getItem("pageSize"));
        this.queryForm = JSON.parse(sessionStorage.getItem("queryCriteria"));
        this.init(false);
        sessionStorage.removeItem("detail");
      } else {
        this.init(true);
        //这个主要是从其他页面第一次进入列表页，清掉缓存里面的数据
        sessionStorage.removeItem("currentPage");
        sessionStorage.removeItem("total");
      }
    },
    closeDialog() {
      this.init(false);
    }
  },
  mounted() {
    this.getInit();
  }
};
</script>

<style lang="scss" scoped>
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}

>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}

>>> .el-table__row {
  height: 42px;
}

>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 0.5px solid rgb(170, 170, 170);
}

>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}

.preSpecificContent {
  font-family: "微软雅黑", sans-serif;
  font-weight: 400;
  color: #666666;
  font-size: 14px;
  white-space: pre-wrap;
  word-wrap: break-word;
  margin: 0px;
}
>>> .el-input--courseSelect .el-input__inner {
  height: 32px !important;
}
.el-button--submit {
  height: 32px;
}
>>> .buttonWidth {
  width: 80px;
  height: 32px;
  background-color: rgb(255, 255, 255);
  color: rgb(0, 176, 240);
}
//弹窗样式
>>> .roll-dialog .el-dialog__body {
  padding: 3px 30px;
  overflow-y: auto;
  height: calc(80vh - 140px);
}
//弹窗样式
>>> .add_roll-dialog {
  .el-dialog__body {
    padding: 3px 30px;
    overflow-y: auto;
    height: calc(90vh - 140px);
  }
}
.submitButton {
  width: 80px;
  height: 32px;
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/MarketingMgt/P0433.vue